"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayer = void 0;
const registry_call_1 = require("./registry-call");
const contentTypes = require("./content-types");
const options_1 = require("./options");
/**
 * Retrieves a layer blob and returns it as a Buffer.
 *
 * Fetches a container image layer blob from the registry and returns it as a Node.js Buffer.
 * This approach loads the entire blob into memory, so it should only be used for small layers.
 * For large layers, use {@link downloadLayer} to stream to disk instead.
 *
 * OCI Distribution Specification endpoint: `/v2/<name>/blobs/<digest>`
 *
 * ## Caution
 *
 * Blobs are downloaded into RAM, which can cause issues:
 *  - Large blobs can cause RAM exhaustion
 *  - Large blobs can exceed Node.js `buffer.constants.MAX_LENGTH`:
 *    - 32-bit architecture: 2^30 - 1 (about 1 GiB)
 *    - 64-bit architecture:
 *       - Node.js < 22: 2^30 - 1 (about 1 GiB)
 *       - Node.js >= 22: 2^53 - 1 (about 8 PiB)
 *
 * @param registryBase - The base URL of the container registry
 * @param repo - The repository name (e.g., "library/nginx")
 * @param digest - The layer blob digest (e.g., "sha256:abc123...")
 * @param username - Optional username for authentication
 * @param password - Optional password for authentication
 * @param options - Optional request configuration options (acceptLayer can customize content type)
 * @param observer - Optional observer to record client events
 *
 * @returns Layer blob as a Buffer
 *
 * @throws {NeedleWrapperException} When blob not found or HTTP errors occur
 * @throws {RangeError} When blob exceeds Node.js buffer size limits
 *
 * @see {@link downloadLayer} for streaming large blobs to disk
 */
async function getLayer(registryBase, repo, digest, username, password, options = {}, observer) {
    var _a;
    const cloned = (0, options_1.cloneOptions)(options);
    const accept = `${(_a = cloned.acceptLayer) !== null && _a !== void 0 ? _a : contentTypes.LAYER}`;
    const endpoint = `/${repo}/blobs/${digest}`;
    const layerResponse = await (0, registry_call_1.registryV2Call)(registryBase, endpoint, accept, username, password, cloned, observer, { kind: "buffered" });
    // When the content type is wrongly set to text instead of binary, response body is returned as string instead of a buffer
    // This forces a buffer response.
    if (!(layerResponse.body instanceof Buffer)) {
        return Buffer.from(layerResponse.raw);
    }
    return layerResponse.body;
}
exports.getLayer = getLayer;
//# sourceMappingURL=get-layer.js.map